import Reporting from './Reporting';
import LoadUserData from '../../LoadUserData';

export const ReportingConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth: ['reporting','super'],
    routes  : [
        {
            path     : '/reporting/:report',
            component: LoadUserData(Reporting)
        },
        {
            path     : '/reporting',
            component: LoadUserData(Reporting)
        }
    ]
};
